import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const HomesContext = createContext();

export const useHomes = () => {
  const context = useContext(HomesContext);
  if (!context) {
    throw new Error('useHomes must be used within a HomesProvider');
  }
  return context;
};

export const HomesProvider = ({ children }) => {
  const [homes, setHomes] = useState([]);
  const [selectedHomeId, setSelectedHomeId] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const loadHomes = async () => {
    try {
      setLoading(true);
      setError('');
      const res = await axios.get('/api/netatmo/homes');
      const list = res.data.homes || [];
      setHomes(list);
      
      // Auto-select first home if nothing is selected
      if (!selectedHomeId && list.length > 0) {
        setSelectedHomeId(list[0].id);
      }
    } catch (e) {
      console.error('Failed to load homes:', e);
      setError('Failed to load homes');
    } finally {
      setLoading(false);
    }
  };

  const selectedHome = homes.find(h => h.id === selectedHomeId) || null;

  const value = {
    homes,
    selectedHomeId,
    setSelectedHomeId,
    selectedHome,
    loading,
    error,
    loadHomes,
  };

  return (
    <HomesContext.Provider value={value}>
      {children}
    </HomesContext.Provider>
  );
};
